import { getLenisInstance } from '../core/scroll-manager.js';
import { initializeScrollEffects } from '../core/scroll-effects.js';
import { initializeTextAnimations } from './text-animations.js';

let initialized = false;

export function initializeAlmFeatures() {
    if (initialized) return;
    initialized = true;


    // Listen for Ajax Load More complete event
    window.almComplete = function(alm) {
        setTimeout(() => {
            initializeScrollEffects();
            initializeTextAnimations();
        }, 100); 

        window.dispatchEvent(new CustomEvent('alm:complete', { detail: alm }));
    };

    setTimeout(() => {
        initializeScrollEffects();
    }, 100);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'aria-expanded') {
                const target = mutation.target;
                if (target.classList.contains('alm-filter--toggle') && target.getAttribute('aria-expanded') === 'true') {
                    const expandedToggles = document.querySelectorAll('.alm-filter--toggle[aria-expanded="true"]');
                    expandedToggles.forEach((toggle) => {
                        if (toggle !== target) {
                            toggle.setAttribute('aria-expanded', 'false');

                            const parent = toggle.closest('.alm-filter');
                            if (parent) {
                                const inner = parent.querySelector('.alm-filter--inner');
                                if (inner) {
                                    inner.style.display = 'none';
                                }
                            }
                        }
                    });
                }
            }
        });
    });

    observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['aria-expanded']
    });

    const updateFilterCount = (group) => {
        const count = group.querySelectorAll('.alm-filter--link.active').length;
        const parent = group.closest('.alm-filter');
        const toggle = parent ? parent.querySelector('.alm-filter--toggle') : null;
        if (toggle) {
            if (count > 0) {
                toggle.style.setProperty('--count', `"${count}"`);
            } else {
                toggle.style.removeProperty('--count');
            }
        }
    };

    document.querySelectorAll('.alm-filter--group').forEach(updateFilterCount);

    document.addEventListener('click', (e) => {
        const link = e.target.closest('.alm-filter--link');
        if (link) {
            const group = link.closest('.alm-filter--group');
            if (group) {
                setTimeout(() => updateFilterCount(group), 50);
            }
        }

        if (e.target.closest('.filter-toggle')) {
            document.body.classList.toggle('filter-open');

            if (document.body.classList.contains('filter-open')) {
                const lenis = getLenisInstance();
                const filterWrap = document.querySelector('.filter-wrap');
                const header = document.getElementById('header');
                const wpAdminBar = document.getElementById('wpadminbar');

                if (lenis && filterWrap) {
                    const rect = filterWrap.getBoundingClientRect();
                    if (rect.top > 0) {
                        let offset = 0;
                        if (header) offset += header.offsetHeight;
                        if (wpAdminBar) offset += wpAdminBar.offsetHeight;

                        lenis.scrollTo(filterWrap, {
                            offset: -offset
                        });
                    }
                }
            }
        }

        if (e.target.closest('.alm-filters--button, .alm-filters--reset-button, .alm-filters--submit > button, .alm-filters--reset > button')) {
            document.body.classList.remove('filter-open');

            if (e.target.closest('.alm-filters--reset-button, .alm-filters--reset > button')) {
                document.querySelectorAll('.alm-filter--group').forEach((group) => {
                    const parent = group.closest('.alm-filter');
                    const toggle = parent ? parent.querySelector('.alm-filter--toggle') : null;
                    if (toggle) toggle.style.removeProperty('--count');
                });
            }

            const expandedToggles = document.querySelectorAll('.alm-filter--toggle[aria-expanded="true"]');
            expandedToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false');

                const parent = toggle.closest('.alm-filter');
                if (parent) {
                    const inner = parent.querySelector('.alm-filter--inner');
                    if (inner) {
                        inner.style.display = 'none';
                    }
                }
            });
        }

        if (!e.target.closest('.filter-wrap > div')) {
            const expandedToggles = document.querySelectorAll('.alm-filter--toggle[aria-expanded="true"]');
            expandedToggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false');

                const parent = toggle.closest('.alm-filter');
                if (parent) {
                    const inner = parent.querySelector('.alm-filter--inner');
                    if (inner) {
                        inner.style.display = 'none';
                    }
                }
            });
        }
    });
}